import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import {
  Button,
  Grid,
  Icon,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  ListItemAvatar,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import { PROGRAMS } from '../../../utils/lists'

class PlanAssistance extends Component {
  constructor(props) {
    super(props)

    this.state = {
      assistance: 'ai_planner',
    }
  }

  submitRequest = () => {
    this.props.onUpdated({assistance: this.state.assistance})
  }

  render() {
    const { classes, user } = this.props

    return (
      <Fragment>
        <Grid item xs={12} md={8}>
          <List className={classes.menu}>
          {PROGRAMS.slice(0, 3).map((program, i) => {
            return <ListItem button disabled={program.disabled}
                    key={program.value}
                    onClick={() => this.setState({assistance: program.value})}
                    classes={{root: (this.state.assistance === program.value ? classes.listItemSelected : classes.listItem)}}
                    >
              <ListItemAvatar classes={{root: classes.listItemAvatar}}>
                <Icon className="material-icons-outlined notranslate">{this.state.assistance === program.value ? 'radio_button_checked' : 'radio_button_unchecked'}</Icon>
              </ListItemAvatar>
              <ListItemText
                primary={program.title}
                secondary={program.description}
                classes={{primary: classes.listItemText, secondary: classes.listItemTextSecondary}}
              />
              <ListItemSecondaryAction onClick={() => this.setState({assistance: program.value})} classes={{root: classes.listItemTextPrice}}>

                {<div style={{maxWidth: 100, display: 'inline-block', whiteSpace: 'normal', textAlign: 'right', float: 'right', verticalAlign: 'middle', opacity: (program.disabled ? 0.3 : 1)}}>
                  {program.costs === 0 ? 'Free' : new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: this.state.currency || 'USD'}).format(program.costs)}{program.pricePer ? ' /' + program.pricePer : ''}
                </div>}
                {program.original_price && <div style={{color: '#828282', fontSize: '97%', fontWeight: 700, maxWidth: 100, display: 'block', whiteSpace: 'normal', textAlign: 'right', verticalAlign: 'middle', textDecoration: 'line-through'}}>
                  {new Intl.NumberFormat([], {style: 'currency', minimumFractionDigits: 0, maximumFractionDigits: 2, currency: this.state.currency || 'USD'}).format(program.original_price)}
                </div>}
              </ListItemSecondaryAction>
            </ListItem>
          })}
          </List>

          <h3 className={classes.subtitle} style={{textAlign: 'center'}}>
            <Icon className="material-icons-outlined notranslate" style={{verticalAlign: 'middle', padding: '0px 5px'}}>workspace_premium</Icon>
            7-day money back guarantee
          </h3>
        </Grid>

        <Grid item xs={12} md={8} style={{margin: 'auto'}}>
          <Button disabled={!(this.state.assistance) || this.props.isSubmitting} onClick={this.submitRequest} variant="contained" color="primary" size="large" className={classes.buttonBook}>
            {this.props.isSubmitting ?
              <Fragment>Sending...</Fragment>
              :
              <Fragment>Confirm</Fragment>
            }
          </Button>
        </Grid>
      </Fragment>
    )
  }
}

const styles = theme => ({
  subtitle: {
    fontWeight: 800,
    fontSize: '14px !important',
    // fontSize: '12px',
    color: '#02c39a',
    display: 'block',
    margin: '0px 0px 30px 0px',
  },
  listItemIcon: {
    color: '#02c39a',
  },
  listItemAvatar: {
    minWidth: 40,

    '& .material-icons': {
      color: '#02c39a',
      fontWeight: 300,
      verticalAlign: 'middle',
      margin: '-3px 0px 0px 0px',
    }
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '70%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextPrice: {
    fontSize: 15,
    fontWeight: 600,
    maxWidth: '90%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',
  },
  listItemSelected: {
    borderRadius: 15,
    border: '1px solid #02c39a',
    marginBottom: 5,

    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  listItem: {
    borderRadius: 15,
    border: '1px solid transparent',
    marginBottom: 5,
    backgroundColor: '#fbfbfb',

    '&:hover': {
      backgroundColor: '#07c3991a',
    },

    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
})

export default withRouter(withStyles(styles)(PlanAssistance))
